import React from 'react';
import { Link } from 'react-router';

export default class AboutPage extends React.Component {
  render() {
    return (
      <div id="overview">
        <h2>About</h2>
        <p>
          Emmy kassa van Clixx. Made by Sintrum IT
        </p>
        <p>
          <Link to="/badlink">Click this bad link</Link> to see the 404 page.
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/AboutPage.jsx